import { ParticipantTaskSharedService } from '@wealthlane/api-services/wealthlane-award-service';
import { createEntityMutation } from '../../createEntityMutation';
import type { AcceptSarAwardPayload, AcceptSarAwardResponse } from './types';

export const useAcceptSarAward = createEntityMutation<
  AcceptSarAwardResponse,
  AcceptSarAwardPayload
>({
  mutationFn: (payload) =>
    ParticipantTaskSharedService.postApiAwardApiAppParticipantTaskAcceptSarAward({
      Id: payload.id,
      Signature: payload.signature,
      AcceptedDate: payload.acceptedDate,
    }),
  invalidateKeys: ['myHoldingsSarAwards', 'getMyHoldingOverview'],
});
